import { useRecoilTask } from 'recoil-toolkit';

import { userFunctionsDefaultState } from './atoms';
import { getUserFunctionsDefaultTask } from './tasks';

export const useUserFunctionsDefaultList = () => useRecoilTask(getUserFunctionsDefaultTask, [], {
  dataSelector: userFunctionsDefaultState,
  errorStack: true,
});
